import type { Session } from "../session";
import type { tags } from "../tags";

export function tags_fromSession(session: Session) {
	return {
		"zeller.session.clientName": session.clientName,
		"zeller.session.clientVersion": session.clientVersion,
		"zeller.session.vendorName": session.vendorName,
		"zeller.session.vendorApplicationName": session.vendorApplicationName,
		"zeller.session.vendorApplicationVersion": session.vendorApplicationVersion,
		"zeller.session.vendorDeviceType": session.vendorDeviceType,
	} satisfies tags.Tags;
}
